/* kjp-features.js — custom-kit builder, panel features of 12-Oct-2026 (STAGING first; go-live re-applies)
   1. Quote carries the design: front + back JPEG snapshots of the 3D viewer (+ roster.csv) are appended to the
      existing /quote multipart as contact[attachment_N] (same naming, <= 8 files, each image <= ~600 KB).
      Thumbnails show in the quote modal. Any failure = quote goes without images.
   2. Team roster: "Paste roster" (Name, Number, Size — comma/semicolon/tab, Excel/Sheets paste) and "Upload CSV",
      validated (size XS..3XL, number 0-99 or blank) with per-row errors; valid rows feed the existing roster,
      which already drives the size quantities (MOQ). Clicking a player turns the 3D model to the back and shows
      a small back preview with that player's name + number.
   3. Share: native share sheet with the front PNG + design link when the device can share files; link-only
      share otherwise; falls back to the existing Copy link button.
   4. Zoom buttons lose their highlight when the garment changes.
   Talks to kjp.js only through window.KJP_API (exposed by a one-line patch) and to the viewer through
   KibiJersey3D instance .snap(view, maxPx, bg). */
(function () {
  'use strict';
  var MAX_ATT = 8, IMG_MAX_BYTES = 600 * 1024, SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
  var SIZE_ALIAS = { XXS: 'XS', XSMALL: 'XS', 'X-SMALL': 'XS', SMALL: 'S', SM: 'S', MEDIUM: 'M', MED: 'M', LARGE: 'L', LG: 'L',
    XLARGE: 'XL', 'X-LARGE': 'XL', XXL: '2XL', '2X': '2XL', XXXL: '3XL', '3X': '3XL' };

  function api() { return window.KJP_API || null; }
  function viewer() { var a = api(); var v = a && a.cfg ? a.cfg() : null; return v && v.snap ? v : null; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, cls, txt) { var e = document.createElement(tag); cls && (e.className = cls); txt != null && (e.textContent = txt); return e; }

  function dataUrlToBlob(d) {
    var i = d.indexOf(','), meta = d.slice(0, i), b = atob(d.slice(i + 1)), n = b.length, u = new Uint8Array(n);
    while (n--) u[n] = b.charCodeAt(n);
    return new Blob([u], { type: (/:(.*?);/.exec(meta) || [])[1] || 'application/octet-stream' });
  }
  function bytesOf(d) { return Math.floor((d.length - d.indexOf(',') - 1) * 3 / 4); }
  /* synchronous on purpose: keeps navigator.share() inside the click's user activation */
  function snapUrl(view, type, maxPx) {
    var v = viewer(); if (!v) return null;
    var c = v.snap(view, maxPx || 900, '#F4F2FA'); if (!c) return null;
    var d;
    if (type === 'png') { d = c.toDataURL('image/png'); if (bytesOf(d) <= IMG_MAX_BYTES) return d; }
    for (var q = 0.86; q > 0.3; q -= 0.12) { d = c.toDataURL('image/jpeg', q); if (bytesOf(d) <= IMG_MAX_BYTES) return d; }
    return null;
  }
  function toFile(blob, name) {
    try { return new File([blob], name, { type: blob.type }); } catch (e) { blob.name = name; return blob; }
  }

  /* ─────────────── 1. design preview attached to the quote ─────────────── */
  var prepared = null; /* {files:[File front, File back]} built when the quote modal opens */
  function prepareQuotePreview() {
    prepared = null;
    var box = $('[data-kjp-qprev]'), imgs = $('[data-kjp-qprev-imgs]');
    try {
      var out = [];
      [['front', 'kibi-design-front.jpg'], ['back', 'kibi-design-back.jpg']].forEach(function (p) {
        var d = snapUrl(p[0], 'jpeg', 900);
        d && out.push({ url: d, file: toFile(dataUrlToBlob(d), p[1]), view: p[0] });
      });
      if (out.length) prepared = { files: out.map(function (o) { return o.file; }) };
      if (box && imgs) {
        imgs.replaceChildren();
        out.forEach(function (o) {
          var im = el('img'); im.src = o.url; im.alt = 'Design preview, ' + o.view; im.width = 56; im.height = 64;
          imgs.appendChild(im);
        });
        box.hidden = !out.length;
      }
    } catch (e) { prepared = null; box && (box.hidden = true); }
  }
  function rosterCsv(roster) {
    var q = function (s) { s = String(s == null ? '' : s); return /[",\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s; };
    return 'Name,Number,Size\r\n' + roster.map(function (p) { return [q(p.name), q(p.number), q(p.size)].join(','); }).join('\r\n') + '\r\n';
  }
  /* called synchronously by kjp.js inside the quote submit handler, after the shopper's own files */
  window.KJP_QUOTE_EXTRAS = function (fd, used) {
    var a = api(), S = a && a.S, extra = [];
    try { prepared && prepared.files.forEach(function (f) { extra.push(f); }); } catch (e) {}
    try {
      if (S && S.roster && S.roster.length) extra.push(toFile(new Blob([rosterCsv(S.roster)], { type: 'text/csv' }), 'roster.csv'));
    } catch (e) {}
    extra = extra.slice(0, Math.max(0, MAX_ATT - (used || 0)));
    var names = [];
    extra.forEach(function (f, i) { fd.append('contact[attachment_' + ((used || 0) + i + 1) + ']', f, f.name); names.push(f.name); });
    if (names.length) {
      var b = fd.get('contact[body]') || '';
      fd.set('contact[body]', b + '\nDesign files attached: ' + names.join(', '));
    }
    return names.length;
  };

  /* ─────────────── 2. roster paste / CSV ─────────────── */
  function normSize(t) {
    var u = String(t || '').trim().toUpperCase().replace(/\s+/g, '');
    if (SIZES.indexOf(u) >= 0) return u;
    return SIZE_ALIAS[u] || null;
  }
  function splitCsvLine(line) {
    var out = [], cur = '', inq = false;
    for (var i = 0; i < line.length; i++) {
      var ch = line[i];
      if (inq) { if (ch === '"') { if (line[i + 1] === '"') { cur += '"'; i++; } else inq = false; } else cur += ch; }
      else if (ch === '"') inq = true;
      else if (ch === ',' || ch === ';') { out.push(cur); cur = ''; }
      else cur += ch;
    }
    out.push(cur);
    return out;
  }
  function parseLine(line) {
    var f = line.indexOf('\t') >= 0 ? line.split('\t') : /[,;]/.test(line) ? splitCsvLine(line) : null;
    var name = '', num = '', size = '', rawSize = '', errs = [];
    if (f) {
      f = f.map(function (s) { return s.trim(); });
      while (f.length && f[f.length - 1] === '') f.pop();
      /* "Name, Number, Size" is the documented order; also accept any order by content */
      var used = {};
      f.forEach(function (t, i) { if (!size && normSize(t)) { size = normSize(t); used[i] = 1; } });
      if (!size && f.length >= 3) { rawSize = f[2]; used[2] = 1; }
      f.forEach(function (t, i) { if (!used[i] && num === '' && /^#?\d{1,3}$/.test(t)) { num = t.replace('#', ''); used[i] = 1; } });
      name = f.filter(function (t, i) { return !used[i] && t; }).join(' ');
    } else {
      var toks = line.trim().split(/\s+/), rest = [];
      toks.forEach(function (t) {
        if (!size && normSize(t)) size = normSize(t);
        else if (num === '' && /^#?\d{1,3}$/.test(t)) num = t.replace('#', '');
        else rest.push(t);
      });
      name = rest.join(' ');
    }
    if (!size) errs.push(rawSize ? 'size "' + rawSize.slice(0, 8) + '" not in XS–3XL' : 'size missing (XS–3XL)');
    if (num !== '' && (num.length > 2 || +num > 99)) errs.push('number must be 0–99');
    if (name.length > 20) errs.push('name over 20 letters');
    if (!name && num === '') errs.push('needs a name or number');
    return { name: name.slice(0, 40), number: num, size: size || '', errs: errs };
  }
  function isHeader(line) { return /name/i.test(line) && /size/i.test(line) && !/\d/.test(line); }
  function parseRoster(text) {
    var rows = [];
    String(text || '').split(/\r?\n/).forEach(function (line, i) {
      if (!line.trim() || (i === 0 && isHeader(line))) return;
      var r = parseLine(line); r.line = line; rows.push(r);
    });
    return rows;
  }
  function renderPreview(box, rows) {
    box.replaceChildren();
    if (!rows.length) return;
    var ok = rows.filter(function (r) { return !r.errs.length; }).length, bad = rows.length - ok;
    var head = el('p', 'kjp-rp__sum', ok + ' ready' + (bad ? ' · ' + bad + ' need fixing' : ''));
    bad && head.classList.add('has-err');
    var wrap = el('div', 'kjp-rp__wrap'), t = el('table', 'kjp-rp__tbl'), th = el('tr');
    ['#', 'Name', 'No.', 'Size', ''].forEach(function (h) { th.appendChild(el('th', null, h)); });
    var thead = el('thead'); thead.appendChild(th); t.appendChild(thead);
    var tb = el('tbody');
    rows.forEach(function (r, i) {
      var tr = el('tr', r.errs.length ? 'is-err' : null);
      tr.appendChild(el('td', null, String(i + 1)));
      tr.appendChild(el('td', 'kjp-rp__nm', r.name || '—'));
      tr.appendChild(el('td', null, r.number === '' ? '–' : r.number));
      tr.appendChild(el('td', null, r.size || '?'));
      tr.appendChild(el('td', 'kjp-rp__st', r.errs.length ? r.errs.join('; ') : '✓'));
      tb.appendChild(tr);
    });
    t.appendChild(tb); wrap.appendChild(t);
    box.appendChild(head); box.appendChild(wrap);
  }

  function initRoster(root) {
    var ta = $('[data-kjp-bulk-text]', root), wrap = $('[data-kjp-bulk-wrap]', root), btn = $('[data-kjp-bulk-import]', root);
    var box = $('[data-kjp-rp]', root), csvBtn = $('[data-kjp-csv-btn]', root), csvIn = $('[data-kjp-csv-input]', root);
    if (!ta || !btn || !box) return;
    ta.placeholder = 'One player per line: Name, Number, Size\nRahul, 7, L\nPriya, 10, M\n(or paste the 3 columns straight from Excel / Google Sheets)';
    var rows = [], tmr = 0;
    function reparse() { rows = parseRoster(ta.value); renderPreview(box, rows); btn.textContent = rows.length ? 'Add ' + rows.filter(function (r) { return !r.errs.length; }).length + ' players' : 'Import players'; }
    ta.addEventListener('input', function () { clearTimeout(tmr); tmr = setTimeout(reparse, 180); });
    /* capture on the root so the old loose importer bound on the button never runs */
    root.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-kjp-bulk-import]')) return;
      e.stopPropagation(); e.preventDefault();
      var a = api(); if (!a || !a.S) return;
      reparse();
      var good = rows.filter(function (r) { return !r.errs.length; }), left = rows.filter(function (r) { return r.errs.length; });
      var room = Math.max(0, 200 - a.S.roster.length);
      good.slice(0, room).forEach(function (r) { a.S.roster.push({ name: r.name, number: r.number, size: r.size }); });
      a.renderRoster(); a.syncSizes(); a.render();
      ta.value = left.map(function (r) { return r.line; }).join('\n');
      reparse();
      var msg = $('[data-kjp-rp-msg]', root);
      msg && (msg.textContent = good.length ? 'Added ' + Math.min(good.length, room) + ' players' + (left.length ? ' · fix the rows below and add again' : '') : 'No valid rows to add yet');
      if (!left.length && good.length && wrap) setTimeout(function () { wrap.style.display = 'none'; }, 900);
    }, true);
    csvBtn && csvIn && csvBtn.addEventListener('click', function () { csvIn.click(); });
    csvIn && csvIn.addEventListener('change', function () {
      var f = csvIn.files && csvIn.files[0]; if (!f) return;
      if (f.size > 300 * 1024) { var a = api(); a && a.err('CSV must be under 300 KB.'); csvIn.value = ''; return; }
      var rd = new FileReader();
      rd.onload = function () { wrap && (wrap.style.display = ''); ta.value = String(rd.result || '').replace(/^﻿/, ''); reparse(); ta.scrollIntoView({ block: 'nearest' }); };
      rd.readAsText(f); csvIn.value = '';
    });
    /* existing toggle: open it with a fresh preview */
    var tg = $('[data-kjp-bulk-toggle]', root); tg && tg.addEventListener('click', function () { setTimeout(reparse, 0); });

    /* click a player: turn the model to the back and show a small back preview (useful on phones where the
       3D viewer is off-screen) */
    var list = $('[data-kjp-roster-list]', root);
    if (!list) return;
    var pv = el('div', 'kjp-rpv'); pv.hidden = true;
    var pimg = el('img'); pimg.alt = 'Back preview'; pimg.width = 72; pimg.height = 84;
    var ptx = el('span', 'kjp-rpv__t'); pv.appendChild(pimg); pv.appendChild(ptx);
    list.parentNode.insertBefore(pv, list);
    list.addEventListener('click', function (e) {
      var row = e.target.closest && e.target.closest('.kjp-roster-row');
      if (!row || e.target.closest('.kjp-roster-row__rm')) return;
      var a = api(), i = $$('.kjp-roster-row', list).indexOf(row), p = a && a.S && a.S.roster[i];
      var v = viewer(); if (!p) return;
      v && v.setView && v.setView('back');
      $$('[data-kjp-view]').forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-kjp-view') === 'back'); });
      $$('[data-kjp-zoom]').forEach(function (b) { b.classList.remove('active'); });
      setTimeout(function () {
        var d = snapUrl('back', 'jpeg', 360);
        if (!d) { pv.hidden = true; return; }
        pimg.src = d; ptx.textContent = 'Back preview: ' + (p.number !== '' && p.number != null ? '#' + p.number + ' ' : '') + (p.name || '');
        pv.hidden = false;
      }, 160);
    }, true); /* capture: kjp.js re-renders the list on this click, so read the row index before that */
  }

  /* ─────────────── 3. share ─────────────── */
  function initShare() {
    $$('[data-kjp-native-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var a = api(), url = a && a.link ? a.link() : location.href;
        var title = 'Our KIBI Sports custom kit', text = 'Here is our custom kit design. Open the link to see it in 3D:';
        var copy = function () { var c = $('[data-kjp-share]'); c ? c.click() : window.prompt('Copy your design link:', url); };
        if (!navigator.share) { copy(); return; }
        var data = { title: title, text: text, url: url };
        try {
          var d = snapUrl('front', 'png', 1024);
          if (d && navigator.canShare) {
            var f = toFile(dataUrlToBlob(d), 'kibi-kit-design.png');
            var withFile = { files: [f], title: title, text: text, url: url };
            if (navigator.canShare(withFile)) data = withFile;
          }
        } catch (e) {}
        navigator.share(data).catch(function (err) {
          if (err && err.name === 'AbortError') return; /* shopper closed the sheet */
          if (data.files) navigator.share({ title: title, text: text, url: url }).catch(function (e2) { e2 && e2.name !== 'AbortError' && copy(); });
          else copy();
        });
      });
    });
  }

  /* ─────────────── 4. zoom highlight reset on garment change ─────────────── */
  function initZoomReset(root) {
    $$('[data-kjp-product]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-kjp-zoom]').forEach(function (z) { z.classList.remove('active'); });
        $$('[data-kjp-view]').forEach(function (x) { x.classList.toggle('active', x.getAttribute('data-kjp-view') === 'front'); });
      });
    });
  }

  function init() {
    var root = $('[data-kjp]'); if (!root) return;
    initRoster(root); initShare(); initZoomReset(root);
    var qb = $('[data-kjp-quote-btn]', root), ov = $('[data-kjp-overlay]');
    /* kjp.js opens the modal on this same click (bound earlier); build the preview right after it */
    qb && qb.addEventListener('click', function () { setTimeout(function () { ov && ov.classList.contains('open') && prepareQuotePreview(); }, 0); });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  window.KJP_FEATURES = { parseRoster: parseRoster, rosterCsv: rosterCsv, prepareQuotePreview: prepareQuotePreview };
})();
